import moment from 'moment';
import { METRICS_ACTION, SHOW_MESSAGE } from './actionTypes';
import { getAuthHeaders } from './authActions';
import tempMee from '../apis/tempMee';
import { getChallenges, postChallenge, cancelChallenge, getProfChallenges } from '../services/metrics';

export const fetchProfessionalBadges = (userId) => async (dispatch) => {
  try {
    dispatch({ type: METRICS_ACTION.FETCH_HYG_BADGES_REQUEST });

    const headers = await getAuthHeaders();
    const response = await tempMee.get(
      `metrics-service/admin/professional-badges?professionalIds=${userId}`,
      {
        headers,
      },
    );

    const data = response?.data?.data?.[0]?.badges || [];

    dispatch({ type: METRICS_ACTION.FETCH_HYG_BADGES_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: METRICS_ACTION.FETCH_HYG_BADGES_FAILURE, payload: err });
  }
};

export const fetchProfessionalLoyaltyLevel =
  (userIds = []) =>
  async (dispatch) => {
    try {
      dispatch({ type: METRICS_ACTION.FETCH_HYG_LOYALTY_LEVEL_REQUEST });

      const headers = await getAuthHeaders();
      const response = await tempMee.post(
        `metrics-service/admin/professional-loyalty`,
        {
          professionalIds: userIds,
          sortDirection: 'asc',
        },
        {
          headers,
        },
      );

      const loyaltyResponse = response.data?.data;

      dispatch({ type: METRICS_ACTION.FETCH_HYG_LOYALTY_LEVEL_SUCCESS, payload: loyaltyResponse });
    } catch (err) {
      dispatch({ type: METRICS_ACTION.FETCH_HYG_LOYALTY_LEVEL_FAILURE, payload: err });
    }
  };

export const fetchProfessionalPoints =
  ({ userId, event, limit, page } = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: METRICS_ACTION.GET_PROFESSIONAL_POINTS_REQUEST });

      const headers = await getAuthHeaders();
      const response = await tempMee.get(`metrics-service/admin/professional-points/${userId}`, {
        headers,
        params: {
          event,
          limit: limit || 20,
          page,
        },
      });

      dispatch({
        type: METRICS_ACTION.GET_PROFESSIONAL_POINTS_SUCCESS,
        payload: response?.data?.data || {},
      });
    } catch (err) {
      dispatch({
        type: METRICS_ACTION.GET_PROFESSIONAL_POINTS_FAILURE,
        payload: err,
      });
    }
  };

export const fetchProperksChallenge =
  ({ status, limit = 20, page } = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: METRICS_ACTION.GET_PROPERKS_CHALLENGE_REQUEST });

      const response = await getChallenges({
        status,
        limit,
        page,
      });

      dispatch({
        type: METRICS_ACTION.GET_PROPERKS_CHALLENGE_SUCCESS,
        payload: {
          data: response?.data || {},
          filter: {
            status,
            limit,
            page,
          }
        },
      });
    } catch (err) {
      dispatch({
        type: METRICS_ACTION.GET_PROPERKS_CHALLENGE_FAILURE,
        payload: err,
      });
    }
  };


export const launchProperksChallenge =
  (data = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: METRICS_ACTION.LAUNCH_PROPERKS_CHALLENGE_REQUEST });

      await postChallenge(data);
      
      dispatch(fetchProperksChallenge({...getState().metrics?.properksFilter, page: 1}));
      dispatch({
        type: METRICS_ACTION.LAUNCH_PROPERKS_CHALLENGE_SUCCESS,
        payload: {
          ...data,
          created_by: getState()?.users?.adminUser?.email_id || '',
          id: `new-${data?.name}`,
        },
      });
      dispatch({
        type: SHOW_MESSAGE,
        payload: {
          message: 'New Challenge Successfully Launched',
        },
      });
    } catch (err) {
      dispatch({
        type: METRICS_ACTION.LAUNCH_PROPERKS_CHALLENGE_FAILURE,
        payload: err,
      });
    }
  };

export const cancelProperksChallenge = (id) => async (dispatch) => {
  try {
    dispatch({ type: METRICS_ACTION.CANCEL_PROPERKS_CHALLENGE_REQUEST });

    await cancelChallenge(id)

    dispatch({
      type: METRICS_ACTION.CANCEL_PROPERKS_CHALLENGE_SUCCESS,
      payload: id
    });
    dispatch({
      type: SHOW_MESSAGE,
      payload: {
        message: 'Challenge is cancelled ',
      },
    });
  } catch (err) {
    dispatch({
      type: METRICS_ACTION.CANCEL_PROPERKS_CHALLENGE_FAILURE,
      payload: err,
    });
  }
};

export const relaunchProperksChallenge =
  (payload = {}) =>
  async (dispatch) => {
    dispatch({
      type: METRICS_ACTION.RELAUNCH_PROPERKS_CHALLENGE,
      payload: {
        name: payload?.name,
        count: payload?.completed_count,
        type: payload?.type,
        reward: payload?.reward,
        dateRange: { 
          from: moment(payload?.date_start).toDate(),
          to: moment(payload?.date_end).toDate()
        },
        professionType: payload?.professions || [],
        levels: payload?.levels || [],
        states: payload?.states || [],
      },
    });
  };

export const fetchProperksProfessionalChallenge =
  ({ profId, status, limit, page } = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: METRICS_ACTION.GET_PROPERKS_PROFESSIONAL_CHALLENGE_REQUEST });

      const response = await getProfChallenges({ profId, status, limit, page });

      dispatch({
        type: METRICS_ACTION.GET_PROPERKS_PROFESSIONAL_CHALLENGE_SUCCESS,
        payload: response?.data || {},
      });
    } catch (err) {
      dispatch({
        type: METRICS_ACTION.GET_PROPERKS_PROFESSIONAL_CHALLENGE_FAILURE,
        payload: err,
      });
    }
  };